package ru.villawonka.app.presentation.screens.search.compose.view

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Colors
import androidx.compose.material.Icon
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import ru.villawonka.app.presentation.design.components.AppBadge
import ru.villawonka.app.presentation.design.components.AppBadgeType
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppColors
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import villawonka.composeapp.generated.resources.Res
import villawonka.composeapp.generated.resources.ic_filter_24

@Composable
fun FilterButton(
    text: String,
    hasFilters: Boolean = false,
    onClickListener: (() -> Unit)? = null
) {
    Row(
        modifier = Modifier
            .background(
                color = MaterialTheme.colors.filledFilterBackgroundStandart,
                shape = RoundedCornerShape(12.dp),
            )
            .clip(RoundedCornerShape(12.dp))
            .clickable {
                onClickListener?.invoke()
            }
            .padding(
                vertical = 8.dp,
                horizontal = 16.dp
            )
        ,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Icon(
           painter = painterResource(Res.drawable.ic_filter_24),
           contentDescription = null,
           tint = MaterialTheme.colors.filledFilterContentEnabled,
           modifier = Modifier.size(24.dp)
        )
        AppSpacer(4.dp)
        Text(
            text = text,
            style = AppTextStyles.labelMediumMedium,
            color = MaterialTheme.colors.filledFilterContentEnabled
        )
        if (hasFilters) {
            AppSpacer(4.dp)
            AppBadge(type = AppBadgeType.INFO)
        }
    }
}

val Colors.filledFilterContentEnabled
    get() = if (isLight) AppColors.grayLight950 else AppColors.grayDark50

val Colors.filledFilterBackgroundStandart
    get() = if (isLight) AppColors.grayLight100 else AppColors.grayDark950